import { TourStepProps } from 'antd';
import { TFunction } from 'i18next';

export type StepReferences = {
  userProfile: HTMLElement;
  helpSection: HTMLElement;
  organizationSection: HTMLElement;
  plants: HTMLElement;
  createPlant: HTMLElement;
  viewDeactivatePlant: HTMLElement;
  scenarios: HTMLElement;
  createScenario: HTMLElement;
  viewDeactivateScenario: HTMLElement;
  storageSystems: HTMLElement;
  createStorageSystem: HTMLElement;
  viewDeactivateStorageSystem: HTMLElement;
  createSimulation: HTMLElement;
  simulationAssets: HTMLElement;
  assetSelectionEmptyFace: HTMLElement;
  assetSelectionFillFace: HTMLElement;
  reviewSimulationAssets: HTMLElement;
  runningSimulation: HTMLElement;
  completedSimulation: HTMLElement;
  //exampleSimulation: HTMLElement;
};

export const getTourSteps = (
  stepReferences: StepReferences,
  t: TFunction
): TourStepProps[] => [
  //0
  {
    title: t('components.productTourSteps.userProfile.title'),
    description: t('components.productTourSteps.userProfile.description'),
    target: () => stepReferences.userProfile,
    placement: 'left',
    style: {
      right: '180px',
      top: '65px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //1
  {
    title: t('components.productTourSteps.helpSection.title'),
    description: t('components.productTourSteps.helpSection.description'),
    target: () => stepReferences.helpSection,
    placement: 'left',
    style: {
      right: '332px',
      top: '65px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //2
  {
    title: t('components.productTourSteps.organizationSection.title'),
    description: t(
      'components.productTourSteps.organizationSection.description'
    ),
    target: () => stepReferences.organizationSection,
    placement: 'left',
    style: {
      right: '485px',
      top: '65px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //3
  {
    title: t('components.productTourSteps.plants.title'),
    description: t('components.productTourSteps.plants.description'),
    target: () => stepReferences.plants,
    placement: 'right',
    style: {
      left: '225px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //4
  {
    title: t('components.productTourSteps.createPlant.title'),
    description: t('components.productTourSteps.createPlant.description'),
    target: () => stepReferences.createPlant,
    placement: 'left',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //5
  {
    title: t('components.productTourSteps.viewDeactivatePlant.title'),
    description: t(
      'components.productTourSteps.viewDeactivatePlant.description'
    ),
    target: () => stepReferences.viewDeactivatePlant,
    placement: 'left',
    style: {
      top: '420px',
      right: '185px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //6
  {
    title: t('components.productTourSteps.scenarios.title'),
    description: t('components.productTourSteps.scenarios.description'),
    target: () => stepReferences.scenarios,
    placement: 'right',
    style: {
      left: '225px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //7
  {
    title: t('components.productTourSteps.createScenario.title'),
    description: t('components.productTourSteps.createScenario.description'),
    target: () => stepReferences.createScenario,
    placement: 'left',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //8
  {
    title: t('components.productTourSteps.viewDeactivateScenario.title'),
    description: t(
      'components.productTourSteps.viewDeactivateScenario.description'
    ),
    target: () => stepReferences.viewDeactivateScenario,
    placement: 'left',
    style: {
      top: '415px',
      right: '185px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //9
  {
    title: t('components.productTourSteps.storageSystems.title'),
    description: t('components.productTourSteps.storageSystems.description'),
    target: () => stepReferences.storageSystems,
    placement: 'right',
    style: {
      left: '225px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //10
  {
    title: t('components.productTourSteps.createStorageSystem.title'),
    description: t(
      'components.productTourSteps.createStorageSystem.description'
    ),
    target: () => stepReferences.createStorageSystem,
    placement: 'left',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //11
  {
    title: t('components.productTourSteps.viewDeactivateStorageSystem.title'),
    description: t(
      'components.productTourSteps.viewDeactivateStorageSystem.description'
    ),
    target: () => stepReferences.viewDeactivateStorageSystem,
    placement: 'left',
    style: {
      top: '415px',
      right: '185px',
    },
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //12
  {
    title: t('components.productTourSteps.createSimulation.title'),
    description: t('components.productTourSteps.createSimulation.description'),
    target: () => stepReferences.createSimulation,
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //13
  {
    title: t('components.productTourSteps.simulationAssets.title'),
    description: t('components.productTourSteps.simulationAssets.description'),
    target: () => stepReferences.simulationAssets,
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //14
  {
    title: t('components.productTourSteps.assetSelectionEmpty.title'),
    description: t(
      'components.productTourSteps.assetSelectionEmpty.description'
    ),
    target: () => stepReferences.assetSelectionEmptyFace,
    placement: 'top',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //15
  {
    title: t('components.productTourSteps.assetSelectionFill.title'),
    description: t(
      'components.productTourSteps.assetSelectionFill.description'
    ),
    target: () => stepReferences.assetSelectionFillFace,
    placement: 'top',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //16
  {
    title: t('components.productTourSteps.reviewSimulationAssets.title'),
    description: t(
      'components.productTourSteps.reviewSimulationAssets.description'
    ),
    target: () => stepReferences.reviewSimulationAssets,
    placement: 'bottom',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //17
  {
    title: t('components.productTourSteps.runningSimulation.title'),
    description: t('components.productTourSteps.runningSimulation.description'),
    target: () => stepReferences.runningSimulation,
    placement: 'bottom',
    nextButtonProps: {
      children: t('components.productTour.buttons.next'),
    },
    prevButtonProps: {
      style: {
        display: 'none',
      },
    },
  },
  //18
  {
    title: t('components.productTourSteps.completedSimulation.title'),
    description: t(
      'components.productTourSteps.completedSimulation.description'
    ),
    target: () => stepReferences.completedSimulation,
    placement: 'bottom',
    nextButtonProps: {
      children: t('components.productTour.buttons.finish'),
    },
    prevButtonProps: {
      children: t('components.productTour.buttons.previous'),
    },
  },
  //19
  // {
  //   title: t('components.productTourSteps.exampleSimulation.title'),
  //   description: t('components.productTourSteps.exampleSimulation.description'),
  //   target: () => stepReferences.exampleSimulation,
  //   placement: 'left',
  //   nextButtonProps: {
  //     children: t('components.productTour.buttons.finish'),
  //   },
  //   prevButtonProps: {
  //     children: t('components.productTour.buttons.previous'),
  //   },
  // },
];
